import type { CountryCodeValue } from '~~/types/localization/localizationHelperTypes';

export const getDiscountKeyForTier = (
  cohortKey: string,
  country: CountryCodeValue,
): string => {

  return `${cohortKey}-${(country || '').toUpperCase()}`;

};
